<template>
    <v-layout row wrap text-xs-center>
        <v-flex xs12 sm12 md12 lg12 xl12 text-lg-center :class="{ no_progress_bar: !isprogressbar }">
            <v-btn round flat dark @click="Next()" class="next-btn" :class="{ next_btn_active: allfieldsvalid }">{{text}}<span class="icon-next"><IconBase><IconArrowRight /></IconBase></span></v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
// class="educator-route-nav educator-package-nav no_progress_bar"
import IconBase from '@/components/IconBase.vue'
import IconArrowRight from '@/components/icons/arrowForward.vue'
export default {
    name: "ButtonNext",
    components: {
        IconBase,
        IconArrowRight
    },
    props: {
        "text": String,
        "isprogressbar": Boolean,
        "allfieldsvalid": Boolean
    },
    methods: {
        Next() {
            this.$emit("Next");
        }
    }
}
</script>

<style lang="scss" scoped>
.icon-next {
  margin-left: 10px;
  margin-top: 5px
}

.no_progress_bar {
  bottom: 0;
  left:0;
  position: absolute;
  width: 102%;
  background-color: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(30, 29, 29, 0.12);
  box-shadow: 0 0 8px 0 rgba(30, 29, 29, 0.12);
}

@media only screen and (min-width: 0) and (max-width: 640px) {
    .no_progress_bar {
        bottom: 0;
        position:fixed;
    }
}
</style>
